<template>
    <div class="loadmore">
            <div class="loadmore_content"
            v-infinite-scroll = "loadMore"
            infinite-scroll-disabled = 'loading'
            infinite-scroll-distance = '10'
        >
        <slot></slot>
        <!--显示加载中-->
        <li class="loading-box" v-if="isloading">
            <mt-spinner type="snake" id="loading-more"></mt-spinner> 
            <span class="loading-more-txt">加载中...</span>
        </li>
        <!-- 显示没有更多 -->
        <div id="no-more" v-show="noMone">暂无更多数据</div>
    </div>
    </div>
</template>
    
<script>
import { InfiniteScroll,Spinner } from 'mint-ui';
import Vue from "vue";
Vue.use( InfiniteScroll );
Vue.component(Spinner.name, Spinner);
export default {
    name: 'loadmore',
    data () {
        return {
            data:"",
            pageVal: "0",
            pageSize: "10"
        }
    },
    props:{
        loading: {
			default: false//为true时不会触发加载更多，false可以触发
		},
        isloading:{
            default: 0
        },
        noMone:{
            default:false//是否没有更多
        }
    },
    methods: {
        //分页加载更多
        loadMore() {
            this.pageVal++;
            this.$emit("loadmore",this.pageVal);
        }
    }
}
</script>
    
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loadmore{
    display: -webkit-flex;
    flex: 1;
    overflow: scroll;
}
.loadmore #no-more{
    width: 100VW;
    height: 80px;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    font-size:30px;
    border: none;
    padding: 0;
}
.loading-box{
    align-items: center;
    display: -webkit-flex;
    justify-content: center;
}
</style>
          


// WEBPACK FOOTER //
// src/public/loadmore.vue